import React from 'react';
import { motion } from 'framer-motion';
import { Calendar, ShoppingCart, Droplets, Bug, AlertOctagon, Zap } from 'lucide-react';
export function Bonuses() {
  const bonuses = [{
    icon: Zap,
    number: 1,
    title: 'Plan de Inicio de 7 Días',
    description: 'Una hoja de ruta día por día para que en una semana ya tengas tu primera huerta funcionando, sin perderte en teoría.'
  }, {
    icon: Calendar,
    number: 2,
    title: 'Calendario de Cosecha',
    description: 'Sabé exactamente cuándo plantar y cuándo cosechar cada verdura para no perder tiempo.'
  }, {
    icon: ShoppingCart,
    number: 3,
    title: 'Lista de Compras',
    description: 'Lo único que realmente necesitás comprar para arrancar, sin gastar de más en herramientas inútiles.'
  }, {
    icon: Droplets,
    number: 4,
    title: 'Guía de Riego',
    description: 'El secreto exacto de cuánta agua necesita cada planta para no ahogarlas ni secarlas.'
  }, {
    icon: Bug,
    number: 5,
    title: 'Identificación de Plagas',
    description: 'Cómo detectar y eliminar bichos de forma natural antes de que arruinen tu huerta.'
  }, {
    icon: AlertOctagon,
    number: 6,
    title: '10 Errores que Arruinan tu Huerta',
    description: 'Evitá las equivocaciones más comunes que hacen que los principiantes abandonen.'
  }];
  return <section className="w-full py-8 md:py-16 px-4 bg-gradient-to-b from-lime-50 to-white" data-id="element-33">
      <div className="max-w-6xl mx-auto" data-id="element-34">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8 md:mb-12" data-id="element-35">
          <h2 className="text-2xl md:text-4xl font-bold text-gray-900 mb-3 md:mb-4" data-id="element-36">
            🎁 HOY TE LLEVÁS GRATIS
          </h2>
          <p className="text-base md:text-lg text-gray-700" data-id="element-37">
            Además, recibís estos BONOS EXCLUSIVOS sin costo adicional
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6" data-id="element-38">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.08
        }} className="bg-white border-2 border-lime-400 rounded-xl p-5 md:p-6 shadow-lg flex flex-col hover:shadow-xl transition-shadow" data-id="element-39">
              <div className="flex items-start gap-4 mb-4" data-id="element-40">
                <div className="bg-lime-500 text-white p-3 rounded-lg flex-shrink-0" data-id="element-41">
                  <bonus.icon className="w-5 h-5 md:w-6 md:h-6" data-id="element-42" />
                </div>
                <div className="flex-1" data-id="element-43">
                  <div className="text-xs md:text-sm font-bold text-lime-700 mb-1" data-id="element-44">
                    🎁 BONUS #{bonus.number}
                  </div>
                  <h3 className="text-base md:text-lg font-bold text-gray-900 leading-tight" data-id="element-45">
                    {bonus.title}
                  </h3>
                </div>
              </div>

              <p className="text-sm md:text-base text-gray-700 mb-4 flex-1" data-id="element-46">
                {bonus.description}
              </p>

              <div className="border-t-2 border-dashed border-lime-200 pt-3 flex items-center justify-between" data-id="element-47">
                <span className="text-xs md:text-sm text-gray-500 line-through font-medium" data-id="element-48">
                  VALOR: $10.000
                </span>
                <span className="text-xs md:text-sm font-bold text-lime-700 bg-lime-100 px-3 py-1 rounded-full" data-id="element-49">
                  HOY GRATIS
                </span>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}